/* eStylish — global UI */
(function () {
  'use strict';

  function on(sel, evt, fn, root) {
    (root || document).querySelectorAll(sel).forEach(function (el) { el.addEventListener(evt, fn); });
  }

  /* ---- Mobile drawer ---- */
  function initDrawer() {
    var drawer = document.getElementById('MobileDrawer');
    var overlay = document.getElementById('DrawerOverlay');
    if (!drawer) return;
    var lastFocus;
    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var f = drawer.querySelector('a,button');
      if (f) f.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    on('[data-drawer-open]', 'click', open);
    on('[data-drawer-close]', 'click', close);
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---- Search modal ---- */
  function initSearch() {
    var modal = document.getElementById('SearchModal');
    if (!modal) return;
    function open() { modal.classList.add('is-open'); var i = modal.querySelector('input'); if (i) i.focus(); }
    function close() { modal.classList.remove('is-open'); }
    on('[data-search-open]', 'click', function (e) { e.preventDefault(); open(); });
    on('[data-search-close]', 'click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---- Marquee: duplicate track for seamless loop ---- */
  function initMarquee() {
    document.querySelectorAll('.announcement__track').forEach(function (track) {
      if (track.dataset.cloned) return;
      track.innerHTML += track.innerHTML;
      track.dataset.cloned = 'true';
    });
  }

  /* ---- Fade-up on scroll ---- */
  function initReveal() {
    var items = document.querySelectorAll('[data-fade]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (i) { i.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    items.forEach(function (i) { io.observe(i); });
  }

  /* ---- Hero slideshow ---- */
  function initHero() {
    document.querySelectorAll('[data-hero]').forEach(function (hero) {
      var slides = hero.querySelectorAll('.hero__slide');
      if (slides.length < 2) return;
      var dots = hero.querySelectorAll('.hero__dots button');
      var i = 0, timer;
      var interval = parseInt(hero.dataset.interval, 10) || 5000;
      var auto = hero.dataset.autoplay === 'true';
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, x) { s.hidden = x !== i; });
        dots.forEach(function (d, x) { d.setAttribute('aria-current', x === i); });
      }
      function next() { show(i + 1); }
      function start() { if (auto) timer = setInterval(next, interval); }
      function stop() { clearInterval(timer); }
      hero.querySelector('.next') && hero.querySelector('.next').addEventListener('click', function () { stop(); next(); start(); });
      hero.querySelector('.prev') && hero.querySelector('.prev').addEventListener('click', function () { stop(); show(i - 1); start(); });
      dots.forEach(function (d, x) { d.addEventListener('click', function () { stop(); show(x); start(); }); });
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      show(0); start();
    });
  }

  /* ---- Facets drawer (mobile) ---- */
  function initFacets() {
    on('[data-facets-toggle]', 'click', function () {
      var f = document.querySelector('.facets');
      if (f) f.classList.toggle('is-open');
    });
  }

  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  ready(function () { initDrawer(); initSearch(); initMarquee(); initReveal(); initHero(); initFacets(); });

  /* Theme editor re-init */
  document.addEventListener('shopify:section:load', function () { initMarquee(); initHero(); initReveal(); });
})();
